export default class FileUploadService {
    constructor(serverContext) {
        this.serverContext = serverContext;
    }
    async uploadFile(file, fileType = 'merchant', id) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('fileType', fileType || 'merchant');
        if (id) {
            formData.append('id', id);
        }
        formData.append('isPublic', 'true');

        const response = await this.serverContext.files.upload(formData);

        if (response.error !== 'OK') {
            throw new Error(response.error);
        }

        return response.data;
    }

    async getFile(fileName, fileId, fieldName, fileType) {
        // fieldName - type of file (merchantFileType | merchantLocationFileType)
        const file = await this.serverContext.files.getFile(fileName);
        if (file.error !== 'OK') {
            throw new Error(file.error);
        }
        const imageURL = URL.createObjectURL(file.blob);
        return {
            id: fileId,
            name: fileName,
            url: imageURL,
            [fieldName]: fileType
        };
    }
}
